import { c as _c } from "react/compiler-runtime";
import Link from '@/components/elements/Link';
import { ESTABLISHMENT_CITY } from '@/constants/config';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BBookableReceptionTypeEnum, BBookableTypeEnum } from '@/types/backend';
import { ReceptionTypeTag } from '@winelidays/wld-tsx-2/elements';
const RatingsBannerEntityInfo = t0 => {
    const $ = _c(15);
    const { entity, className } = t0;
    const translate = useTranslate();
    const experienceType = Object.values(BBookableTypeEnum).includes(entity.type) ? entity.typeActivity.name : null;
    let t1;
    if ($[0] !== entity.informations || $[1] !== translate) {
        t1 = "receptionType" in entity.informations && entity.informations.receptionType === BBookableReceptionTypeEnum.Private ? <ReceptionTypeTag receptionType={BBookableReceptionTypeEnum.Private} linkComponent={Link} translate={translate}/> : null;
        $[0] = entity.informations;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const privateTag = t1;
    let t2;
    if ($[3] !== entity.name) {
        t2 = <p className="text-2xl font-bold inline align-middle mr-2">{entity.name}</p>;
        $[3] = entity.name;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    let t3;
    if ($[5] !== privateTag || $[6] !== t2) {
        t3 = <div className="mb-2 text-center mdlg:text-left">{t2}{privateTag}</div>;
        $[5] = privateTag;
        $[6] = t2;
        $[7] = t3;
    }
    else {
        t3 = $[7];
    }
    let t4;
    if ($[8] !== experienceType) {
        t4 = experienceType && <p className="mb-2 text-center font-semibold uppercase mdlg:text-left">{experienceType}</p>;
        $[8] = experienceType;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <p className="text-sm font-semibold text-gray-400 text-center mdlg:text-left">{ESTABLISHMENT_CITY}</p>;
        $[10] = t5;
    }
    else {
        t5 = $[10];
    }
    let t6;
    if ($[11] !== className || $[12] !== t3 || $[13] !== t4) {
        t6 = <div className={className}>{t3}{t4}{t5}</div>;
        $[11] = className;
        $[12] = t3;
        $[13] = t4;
        $[14] = t6;
    }
    else {
        t6 = $[14];
    }
    return t6;
};
export default RatingsBannerEntityInfo;
